import React, { useState } from 'react';

import styled from 'styled-components';

const StyledNavSection = styled.ul`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 24px 0;
  & > li {
    &::before {
      content: '';
    }
    &:hover {
      text-decoration: underline;
    }
  }
`;

const navSections = [
  {
    title: 'What Are Empty Leg Flights?',
    id: 'what-emptyLeg',
  },
  {
    title: 'Find Empty Leg Flights',
    id: 'find-emptyLeg',
  },
  {
    title: 'FAQs About Empty Leg Flights',
    id: 'faq-emptyLeg',
  },
];

const NavSection = () => {
  return (
    <StyledNavSection>
      {navSections.map((item) => {
        return (
          <li key={item.id}>
            <a href={`#${item.id}`}>{item.title}</a>
          </li>
        );
      })}
    </StyledNavSection>
  );
};

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0;
  text-align: center;
  text-wrap: balance;
  h1 {
    font-weight: var(--fw-bold);
    font-size: var(--fs-1000);
    color: var(--color-theme);

    margin: 0;
  }
  h2 {
    font-size: var(--fs-900);
    margin: 0;
  }
  h3 {
    font-size: var(--fs-800);
    margin: 0;
  }
  h4 {
    font-size: var(--fs-700);
    margin: 0;
  }
`;

const EmptyLegNav = ({ nav, onSelect }) => {
  const [active, setActive] = useState(0);
  return (
    <>
      <div className="nav_tab">
        {[{ city: 'All Cities' }, ...(nav || [])].map((item, index) => {
          return (
            <button
              key={index}
              className={`${active === index ? 'active' : ''}`}
              onClick={() => {
                setActive(index);
                onSelect(item.city);
              }}
            >
              <span>{item.city}</span>
            </button>
          );
        })}
      </div>
      <Heading>
        <h1>Empty Leg Flights</h1>
        <h4>
          Experience the luxury of private jet travel at a fraction of the cost with flexible,
          convenient, and affordable empty leg flights
        </h4>
      </Heading>
      <NavSection />
    </>
  );
};

export default EmptyLegNav;
